import React from "react";
import styles from "./TeachersScreen.module.scss";

const TeachersScreen = () => {
  return (
    <div>
      <h1> TEACHERS SCREEN</h1>
    </div>
  );
};

export default TeachersScreen;